import { takeEvery, put, call } from "redux-saga/effects";
import {
  getOrderInvoiceErr,
  getOrderInvoiceOk,
} from "./actions";

import {
  getOrderInvoice
} from '~/helpers/backendHelper'

import {
  GET_ORDER_INVOICE,
} from "./actionTypes";

/********** SINGLE **********/

function* onGetOrderInvoice({ payload: { id } }) {
  try {
    const response = yield call(getOrderInvoice, id);
    yield put(getOrderInvoiceOk(response));
  } catch (error) {
    yield put(getOrderInvoiceErr(error));
  }
}

function* orderInvoiceSaga() {
  yield takeEvery(GET_ORDER_INVOICE, onGetOrderInvoice);
}

export default orderInvoiceSaga;